var __DEV__ = process.env.NODE_ENV !== 'production';

export { __DEV__ };